import React, {useMemo, useEffect} from 'react'
import {useTable, useSortBy, useRowSelect,useFilters, usePagination} from 'react-table'
import {COLUMNS} from './columns'
import '../../../stylesheets/table.css'
import { button } from 'semantic-ui-react'
import { Checkbox} from './Checkbox'
import {ColumnFilter} from './ColumnFilter'
import $ from 'jquery';
import track from '../../track';

export const BasicTable = (props) =>{
    /*var navTo = (uri) =>{
        window.location.href = window.location.origin + uri;
    }*/

    const columns = useMemo(()=> COLUMNS,[props])
    const data = useMemo(()=> props.data,[props]) /* use on instructors throuh props*/
    const defaultColumn = useMemo(()=> {
        return{
                Filter: ColumnFilter
            }
            },[props])

    const {
        getTableProps,
        getTableBodyProps,
        headerGroups,
        page,
        nextPage,
        previousPage,
        canNextPage,
        canPreviousPage,
        pageOptions,
        gotoPage,
        pageCount,
        state,
        prepareRow,
        selectedFlatRows
        } = useTable({
            columns: columns,
            data: data,
            defaultColumn: defaultColumn
        },
        useFilters,
        useSortBy,
        usePagination,
        useRowSelect,
        (hooks)=>{
            hooks.visibleColumns.push((columns)=>{
                return [
                    {
                        id:'selection',
                        Header: ()=>(<>Click to Remove</>
                        ),
                        Cell:({row}) => (
                            <Checkbox id='deleteInstructor' {...row.getToggleRowSelectedProps()} />
                        )
                    },
                    ...columns
                ]
            })

        }
    )

    const {pageIndex} = state

    useEffect(() => {
        const x = selectedFlatRows.map((row)=>row.original)    
        if (x.length === 0) {
            //console.log("instructor_id nothing")
        }
        else{
            const y = x[0];
            //console.log('instructor_id to delete',y.id);
            const secondFunction = async () => {
                const result = await props.refreshToken()
                // do something else here after firstFunction completes
                
                $.ajax({
                    url: `/api/classes/${props.classId}/instructors`, //TODO: update request URL
                    type: "POST",
                    beforeSend: function (xhr) {   //Include the bearer token in header
                    xhr.setRequestHeader("Authorization", 'Bearer '+ sessionStorage.getItem("access_token"));
                    },
                    dataType: 'json',
                    contentType: 'application/json',
                    data: JSON.stringify({
                        type:'delete',
                        instructors: [],
                        instructorId: y.id
                    }),
                    xhrFields: {
                    withCredentials: true
                    },
                    crossDomain: true,
                    success: (result) => {
                        //document.location.reload()
                        track(`removed instructor ${y.id}to class of id = ${props.classId} `,
                            'Class.instructors', 'Remove');
          
                        props.reloadClass();
                    return;
                    },
                    error: (error) => {
                    alert('Unable to remove instructor from class. Please try your request again')
                    return;
                    }
                })
            }
            secondFunction();
        }
    },[selectedFlatRows])

    return(
        <div key ={props.data}>
            <table {...getTableProps()}>
                <thead>
                    {headerGroups.map(headerGroup => (
                        <tr {...headerGroup.getHeaderGroupProps()}>
                            {
                                headerGroup.headers.map(column => (
                                    <th {...column.getHeaderProps(column.getSortByToggleProps())}>
                                        {column.render('Header')}
                                        <div>{column.canFilter ? column.render('Filter') : null}</div>
                                        <span>
                                            {column.isSorted ? (column.isSortedDesc ? "▼": "▲"): ''}
                                        </span>
                                    </th>
                                ))
                            }
                            
                        </tr>
                    ))}
                </thead>
                <tbody {...getTableBodyProps()}>
                    {
                        page.map(row => {
                            prepareRow(row)
                            return (
                                <tr {...row.getRowProps()}>
                                    {
                                        row.cells.map((cell) => {
                                            return <td  {...cell.getCellProps()}>
                                                {cell.render('Cell')}
                                            </td>
                                        })
                                    }
                                </tr>
                            )
                        })
                    }

                </tbody>

            </table>
            <div id='prevnext'>
                <span>
                    Page{' '}
                    <strong>
                        {pageIndex +1} of {pageOptions.length}
                    </strong> {' '}
                </span>
                <span>
                    | Go to page: {' '}
                    <input type='number' defaultValue={pageIndex + 1}
                    onChange={e => {
                        const pageNumber = e.target.value ? Number(e.target.value) - 1 : 0
                        gotoPage(pageNumber)
                    }}
                    style = {{width: '50px'}}/>
                </span>
                <button onClick = {()=> gotoPage(0)} disabled={!canPreviousPage}>{'<<'}</button>
                <button onClick = {()=> previousPage()} disabled={!canPreviousPage}>Previous</button>
                <button onClick = {()=> nextPage()} disabled={!canNextPage}>Next</button>
                <button onClick = {()=> gotoPage(pageCount-1)} disabled={!canNextPage}>{'>>'}</button>
            </div>
        </div>
    )
} 